
import AdminLayout from "@/components/admin/AdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";

const AdminAnalytics = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-admin-foreground">Analytics</h1>
          <p className="text-admin-muted-foreground mt-1">
            Comprehensive business insights and reporting
          </p>
        </div>
        
        <Card className="admin-card border-admin-border">
          <CardHeader>
            <CardTitle className="text-admin-foreground flex items-center gap-2">
              <BarChart3 className="h-5 w-5" />
              Business Analytics
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-admin-muted-foreground">
              Advanced analytics features are coming soon. This will include sales reports, 
              user behavior analysis, and performance metrics.
            </p>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminAnalytics;
